export default "__VITE_ASSET__BjOLcCfA__"